export interface HomeFaq {
  q: string;
  a: string;
}

// Homepage FAQ set (also rendered as FAQPage schema on `/`). Kept to print
// intent on purpose: embroidery questions live on /embroidery so the homepage
// stops competing with the dedicated embroidery pages for those queries.
export const homeFaqs: HomeFaq[] = [
  {
    q: 'Can OK T-Shirt deliver custom printed clothing across the UK?',
    a: 'Yes. OK T-Shirt prints and ships custom printed clothing to every postcode in England, Scotland, Wales and Northern Ireland. Standard production and dispatch takes 3–5 working days from artwork approval.',
  },
  {
    q: 'How much does custom t-shirt printing cost in the UK?',
    a: 'Prices depend on the garment, print method, quantity and number of print positions. As a guide, a single printed t-shirt starts from around £12–£15, and bulk orders of 50+ shirts typically work out at £7–£10 each. Larger runs and repeat orders are quoted individually.',
  },
  {
    q: 'What is the minimum order quantity?',
    a: 'There is no minimum order on most products. You can order a single custom t-shirt, hoodie or polo with the same quality as a bulk run. Minimums only apply to a small number of made-to-order garments and we will always flag this before you commit.',
  },
  {
    q: 'Which printing method is best — DTG, DTF or screen printing?',
    a: 'DTG (direct-to-garment) suits full-colour, detailed artwork on light cotton. DTF (direct-to-film) prints vibrantly on any fabric including polyester and dark colours. Screen printing is the most cost-effective for large runs with limited colours. Send us your artwork and we will recommend the print method with the best finish and price.',
  },
  {
    q: 'How fast is UK delivery?',
    a: 'Most custom orders are produced and dispatched within 3–5 working days. Free Local Collection from our Birmingham workshop (126 Beeches Rd, B42 2HQ) is usually ready within 24 hours, and next-day priority courier to UK mainland addresses is available when stock allows — contact us before ordering for urgent jobs.',
  },
  {
    q: 'Do you print for schools, sports clubs and businesses nationwide?',
    a: 'Yes. We supply custom school uniforms, PE kits, sports team kits, staff workwear, hi-vis, hospitality uniforms and event clothing to schools, clubs and businesses across the UK. We can invoice schools and set up approved supplier accounts for repeat orders.',
  },
  {
    q: 'Do you offer bulk discounts?',
    a: 'Yes. Bulk pricing starts from 10 units and improves at 25, 50 and 100+ units. Corporate accounts and repeat customers receive preferential pricing — contact us for a tailored quote based on garment, print method and volume.',
  },
  {
    q: 'What artwork files do you accept?',
    a: 'We accept vector files (AI, EPS, PDF, SVG) and high-resolution PNG or JPG at 300dpi or higher. If your artwork needs cleaning up or you only have a sketch, our in-house design team can prepare a print-ready file for a small fee.',
  },
  {
    q: 'Can I see a sample before placing a bulk order?',
    a: 'Yes. Digital mock-ups are provided free before production. For large orders we also produce a physical pre-production sample so you can approve print colour, placement and garment feel before we print the full run. Physical samples are charged at cost.',
  },
  {
    q: 'Where are you based?',
    a: 'Our clothing printing studio is at 126 Beeches Road, Birmingham, West Midlands (B42 2HQ). We welcome walk-in customers by appointment, but most of our orders are placed online and shipped nationwide across the UK.',
  },
];
